/**
 * @generated SignedSource<<f9e99e1fbe9a6b66d2fd0a655ca1c212>>
 * @relayHash 903fb2ec9f5c8898995222d6cac65bd8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1da15cf236373bb2495fdf6295d8e4feee7ba6cf999bb82faa737d9d50833d6e

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type JiraSuggestedChildIssueStatusType = "COMPLETE" | "REFINING_SUGGESTED_ISSUES" | "REFORMATTING_ISSUES" | "REMOVING_DUPLICATE_ISSUES" | "RETRIEVING_SOURCE_CONTEXT" | "SUGGESTING_INITIAL_ISSUES" | "%future added value";
export type JiraSuggestedIssueErrorType = "COMMUNICATIONS_ERROR" | "NOT_ENOUGH_INFORMATION" | "NO_FURTHER_SUGGESTIONS" | "UNCLASSIFIED" | "UNETHICAL_CONTENT" | "%future added value";
export type JiraSuggestedIssueInput = {
  description?: string | null | undefined;
  summary?: string | null | undefined;
};
export type issueBreakdownSubscription$variables = {
  additionalContext?: string | null | undefined;
  channelId?: string | null | undefined;
  excludeSimilarIssues?: ReadonlyArray<JiraSuggestedIssueInput> | null | undefined;
  issueTypeIds?: ReadonlyArray<string> | null | undefined;
  sourceIssueId: string;
};
export type issueBreakdownSubscription$data = {
  readonly jira: {
    readonly onSuggestedChildIssue: {
      readonly __typename: "JiraSuggestedChildIssueError";
      readonly error: JiraSuggestedIssueErrorType | null | undefined;
    } | {
      readonly __typename: "JiraSuggestedChildIssueStatus";
      readonly channelId: string | null | undefined;
      readonly status: JiraSuggestedChildIssueStatusType | null | undefined;
    } | {
      readonly __typename: "JiraSuggestedIssue";
      readonly description: string | null | undefined;
      readonly issueTypeId: string | null | undefined;
      readonly summary: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type issueBreakdownSubscription = {
  response: issueBreakdownSubscription$data;
  variables: issueBreakdownSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "additionalContext"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channelId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeSimilarIssues"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueTypeIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceIssueId"
},
v5 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "additionalContext",
            "variableName": "additionalContext"
          },
          {
            "kind": "Variable",
            "name": "channelId",
            "variableName": "channelId"
          },
          {
            "kind": "Variable",
            "name": "excludeSimilarIssues",
            "variableName": "excludeSimilarIssues"
          },
          {
            "kind": "Variable",
            "name": "issueTypeIds",
            "variableName": "issueTypeIds"
          },
          {
            "kind": "Variable",
            "name": "sourceIssueId",
            "variableName": "sourceIssueId"
          }
        ],
        "kind": "LinkedField",
        "name": "onSuggestedChildIssue",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "summary"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "kind": "ScalarField",
                "name": "issueTypeId"
              }
            ],
            "type": "JiraSuggestedIssue"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "status"
              },
              {
                "kind": "ScalarField",
                "name": "channelId"
              }
            ],
            "type": "JiraSuggestedChildIssueStatus"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "error"
              }
            ],
            "type": "JiraSuggestedChildIssueError"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueBreakdownSubscription",
    "selections": (v5/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "issueBreakdownSubscription",
    "selections": (v5/*: any*/)
  },
  "params": {
    "id": "1da15cf236373bb2495fdf6295d8e4feee7ba6cf999bb82faa737d9d50833d6e",
    "metadata": {},
    "name": "issueBreakdownSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "cee363799ea6d781699bb631f0927768";

export default node;
